"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZBannerItem = void 0;
const React = __importStar(require("react"));
const ZBanner_1 = require("./ZBanner");
const react_router_dom_1 = require("react-router-dom");
const useLocalizedProps_1 = require("../../languages/useLocalizedProps");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const styled_components_1 = __importDefault(require("styled-components"));
const ZBannerItemComponent = (props) => {
    const { wideEnough } = React.useContext(ZBanner_1.BannerContext);
    const { current, text, link, icon, className, onClick } = useLocalizedProps_1.useLocalizedProps(props);
    const LinkButton = (React.createElement(Button_1.default, { autoCapitalize: "no", style: {
            padding: 0
        }, onClick: onClick, onMouseDown: e => {
            e.preventDefault();
        } },
        React.createElement("div", { className: className }, icon ? (React.createElement("div", { className: "banner-item-icon" }, icon)) : (React.createElement("div", { className: "banner-item-text" },
            text,
            " ")))));
    if (wideEnough || current || props.text === "Home" || props.forceRender) {
        return React.createElement(react_router_dom_1.Link, { to: link }, LinkButton);
    }
    return null;
};
exports.ZBannerItem = styled_components_1.default(ZBannerItemComponent) `
   background: ${props => {
    return props.current
        ? props.theme["banner-skew-background-color"]
        : "transparent";
}};
   text-transform: capitalize;
   height: 40px;
   display: inline-block;
   padding: 5px 15px 0px 15px;
   font-size: 18px;
   line-height: 36px;
   font-weight: bold;
   text-decoration: none;
   align-self: center;
   & .banner-item-icon {
      margin: 0;
      padding: 0;
      height: 30px;
      & svg {
         height: 30px;
         position: relative;
         top: 2px;
      }
   }
   & .banner-item-text {
      font-family: ${props => props.theme["font-family"]};
   }
   color: ${props => props.theme["banner-tab-link-color"]};
   &:hover {
      color: ${props => props.theme["hover-color"]};
      cursor: pointer;
   }
   &:active {
      color: ${props => props.theme["active-color"]};
   }
`;
//# sourceMappingURL=ZBannerItem.js.map